import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import authReducer from './auth/slice'
import organizationsReducer from './organizations/slice'
import gukReducer from './guk/slice'
import participantReducer from './participant'
import organizerReducer from './organizer/slice'

const rootReducer = combineReducers({
  auth: authReducer,
  organizations: organizationsReducer,
  guk: gukReducer,
  participant: participantReducer,
  organizer: organizerReducer
})

const persistConfig = {
  key: 'competitions',
  version: 1,
  storage,
  whitelist: ['auth']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
})

export const persistor = persistStore(store)
export default store
